import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import ProcessPage from "@/pages/ProcessPage";
import AboutPage from "@/pages/AboutPage";
import MaintenancePage from "@/pages/MaintenancePage";
import ContactPage from "@/pages/ContactPage";

// Components
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import MobileCallButton from "@/components/MobileCallButton";

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <BrowserRouter>
        <Navigation />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/processus" element={<ProcessPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/entretien" element={<MaintenancePage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
        <MobileCallButton />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
